import { getRequest, postRequest } from '@bo-apis/axios';

const getUserBySearchOptions = ({ form, pageable }) =>
  postRequest({
    url: `/api/v1/user/get-user-list`,
    params: { ...pageable },
    data: { ...form },
  });

const getUserList = () =>
  getRequest({
    url: `/api/v1/user/get-user-list`,
  });

const getJobGroupPageList = ({ form, pageable }) =>
  postRequest({
    url: '/api/v1/system/user/job-group/get-job-group-list',
    params: { ...pageable },
    data: { ...form },
  });

const getJobGroupList = () =>
  getRequest({
    url: '/api/v1/system/user/job-group/get-job-group-list',
  });

const getUserName = (userId) => {
  if (!userId) {
    return '';
  }
  return getRequest({
    url: `/api/v1/system/user/get-user-name/${userId.trim()}`,
  });
};

export default {
  getUserList,
  getUserBySearchOptions,
  getJobGroupPageList,
  getJobGroupList,
  getUserName,
};
